<template>
    <div class="divider-line"></div>
</template>
<script>
    export default {
        name: 'DividerLine',
    }
</script>
<style scoped lang="scss">
    .divider-line {
        width: 100%;
        height: 5px;
        background: #F3F5F9;
    }
</style>
